<template>
  <div
    class="toggle-switch"
    @click="switched()"
    v-bind:class="{ active: isOn }"
  >
    <div class="knob"></div>
  </div>
</template>

<script>
export default {
  props: ["value"],
  methods: {
    switched() {
      this.isOn = !this.isOn;
      this.$emit("input", this.isOn);
    }
  },
  data: function() {
    return {
      isOn: this.value
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.isOn = value;
      }
    },
    isOn: {
      immediate: true,
      handler(isOn, oldVal) {
        console.log(isOn, oldVal);
      }
    }
  }
};
</script>

<style lang="scss">
.toggle-switch {
  background: #ffffff;
  border: 1px solid #222222;
  border-radius: 10px;
  width: 40px;
  cursor: pointer;
  .knob {
    background: #d8d8d8;
    width: 18px;
    height: 18px;
    margin: 1px;
    border-radius: 10px;
    transition: all 250ms;
  }
  &.active {
    background: #ff5a5f;
    border: 1px solid #ff5a5f !important;
    .knob {
      background: #ffffff;
      transform: translateX(100%);
    }
  }
}
</style>